import axios from 'axios';
import 'url-search-params-polyfill';
import {CONFIG_ENV} from '@/config';
import {IUser} from '@/types/iUser';

interface TNomTipCO {
  id: string, denumire: string
}


interface TAjaxResponseGetUser {
  status: string;
  message: string;
  user: IUser;
}

export class ServicesUser {

  public static async getAppUser(p_lang: string): Promise<TAjaxResponseGetUser> {
    // tslint:disable-next-line:no-console
    console.log('getAppUser with CONFIG_ENV.URL_USER.getUser=%o', CONFIG_ENV.URL_USER.getUser);
    const response = await axios.get(`${CONFIG_ENV.URL_USER.getUser}`);
    return response.data;
  }

  // tslint:disable-next-line:max-line-length
  public static async getNrOfWorkingDays(p_data_start: string, p_data_stop: string): Promise<TAjaxResponseGetUser> {
    const params = new URLSearchParams();
    params.set('data_start', p_data_start);
    params.set('data_stop', p_data_stop);
    const response = await axios.post(`http://hrapp12bcr.bcr.wan/co/json_nr_of_day_between_dates.php`, params);
    return response.data;
  }
}
